import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesInventarios() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Inventario", items: [
      { label: "Inventario", icon: "fas fa-warehouse", color: "#3b82f6", href: "/ListadoInventarios", desc: "Existencias por area", enabled: !!user.inventarios },
      { label: "Tracking", icon: "fas fa-search", color: "#06b6d4", href: "/ListadoTracking", desc: "Seguimiento", enabled: !!user.seguimiento_inventarios },
      { label: "Kardex", icon: "fas fa-clipboard-list", color: "#6366f1", href: "/ListadoKardex", desc: "Movimientos", enabled: !!user.seguimiento_inventarios },
      { label: "Ajuste Inventario", icon: "fas fa-plus", color: "#f59e0b", href: "/ListadoAjustesInventario", desc: "Ajustes de stock", enabled: !!user.ajustesInventario },
      { label: "Inventarios Costos", icon: "fas fa-warehouse", color: "#10b981", href: "/ListadoInventariosCostos", desc: "Valuacion", enabled: !!user.inventarios },
    ]},
    { section: "Traspasos y Muestras", items: [
      { label: "Traspasos Salida", icon: "fas fa-sign-out-alt", color: "#ef4444", href: "/ListadoTraspasosSalida", desc: "Salidas entre areas", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt", color: "#10b981", href: "/ListadoTraspasosEntrada", desc: "Entradas entre areas", enabled: !!user.menu_traspasos_entrada },
      { label: "Muestras Entrada", icon: "fas fa-arrow-down", color: "#14b8a6", href: "/ListadoMuestrasEntrada", desc: "Entrada de muestras", enabled: !!user.menu_traspasos_entrada },
      { label: "Muestras Salida", icon: "fas fa-arrow-up", color: "#8b5cf6", href: "/ListadoMuestrasSalida", desc: "Salida de muestras", enabled: !!user.menu_traspasos_salida },
    ]},
    { section: "Disponibilidad", items: [
      { label: "Disponible", icon: "fas fa-tasks", color: "#3b82f6", href: "/ListadoDisponible", desc: "Stock disponible", enabled: !!user.menu_disponible },
      { label: "Disponible Vendedor", icon: "fas fa-tasks", color: "#6366f1", href: "/ListadoDisponibleVendedor", desc: "Vista vendedor", enabled: !!user.disponible_vendedores },
    ]},
    { section: "Reportes de Precio", items: [
      { label: "Ultimo Precio Cliente", icon: "fas fa-dollar-sign", color: "#f59e0b", href: "/ReporteUltimoPrecio", desc: "Precio por cliente", enabled: !!user.inventarios },
      { label: "Ultimo Precio Articulo", icon: "fas fa-dollar-sign", color: "#14b8a6", href: "/ReporteUltimoPrecioArticulo", desc: "Precio por articulo", enabled: !!user.inventarios },
    ]},
  ];
  return (
    <MenuBotones titulo="Inventarios" descripcion="Existencias, traspasos, muestras y reportes" icono="fas fa-warehouse" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesInventarios;
